import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import * as Yup from 'yup';
import { Field, Form, Formik } from 'formik';
import { AnimatePresence } from 'framer-motion';
import { useDispatch } from 'react-redux';
import { Button, TextInput } from './UI';
import { AppSettings } from '../settings/appSettings';
import { FieldError, Fieldset, FieldWrapper, PasswordRecoveryFormType } from './forms';
import { PopUp } from '../store/animations';
import { queueEmail, readyToBook, sessionId } from '../store/queue/actions';
import { sessionService } from '../services/sessionService';

const initialValues = {
  email: '',
};

export const PreQueue = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const ValidationSchema = Yup.object().shape({
    email: Yup.string().required(t('PasswordRecovery.EmailRequired')).email(t('PasswordRecovery.EmailIncorrect')),
  });

  return (
    <Container>
      <Title>Our site is experiencing high traffic. To get in the queue please log in.</Title>
      <Formik
        initialValues={initialValues}
        validationSchema={ValidationSchema}
        onSubmit={(values: PasswordRecoveryFormType) => {
          const session = sessionService.createSession(values.email);
          dispatch(queueEmail(values.email));
          dispatch(sessionId(session.id));
          dispatch(readyToBook(session.isReady));
        }}
      >
        {({ isValid, handleChange, dirty, handleBlur, values }) => (
          <StyledForm autoComplete="on">
            <StyledFieldset>
              <Field name="email" type="email">
                {({ field, form }) => (
                  <FieldWrapper noted={!!form.touched.email && !!form.errors && !!form.errors.email}>
                    <TextInput
                      placeholder={t('PasswordRecovery.EnterEmail')}
                      type="email"
                      name="email"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.email}
                      error={!!form.touched.email && !!form.errors && !!form.errors.email}
                      {...field}
                    />
                    <AnimatePresence>
                      {!!form.touched.email && !!form.errors && !!form.errors.email && (
                        <FieldError variants={PopUp} initial={'enter'} animate={'exit'} key="error">
                          {form.errors.email}
                        </FieldError>
                      )}
                    </AnimatePresence>
                  </FieldWrapper>
                )}
              </Field>
            </StyledFieldset>
            <Button type="submit" disabled={!isValid || !dirty}>
              Login
            </Button>
          </StyledForm>
        )}
      </Formik>
    </Container>
  );
};

const Title = styled.h1`
  font-size: 2rem;
  color: white;
  margin-bottom: 2rem;
  font-family: Intro, ${AppSettings.DEFAULT_FONTS};
  text-align: center;
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 26px;
  margin-top: auto;
  margin-bottom: auto;
  padding: 0 5%;
`;

const StyledFieldset = styled(Fieldset)`
  flex: 1;
`;

const StyledForm = styled(Form)`
  width: 100%;
  display: flex;
  flex-direction: column;
`;
